import React, { useMemo } from "react";
import type { Meta, StoryObj } from "@storybook/react";
import IdVerificationRetry from "../../screens/auth/IdVerificationRetry";
import { MockedAuthManager } from "../../contexts/AuthManager";
import { buildUser } from "../factories";
import { ProfileType } from "../../__generated__/graphql";
import { MockedProvider } from "@apollo/client/testing";
import { VERIFICATION_RESET } from "../../graphql/identity";
import { MockedProfileSwitcherManager } from "../../contexts/ProfileSwitcherManager";

const StoryComponent = () => {
    const mocks = [
        {
            request: {
                query: VERIFICATION_RESET,
            },
            variableMatcher: () => true,
            newData: () => {
                return {
                    data: {
                        verificationReset: {},
                    },
                };
            },
        },
    ];
    const user = useMemo(buildUser, []);
    return (
        <MockedAuthManager user={user}>
            <MockedProfileSwitcherManager profileType={ProfileType.Client}>
                <MockedProvider mocks={mocks}>
                    <IdVerificationRetry />
                </MockedProvider>
            </MockedProfileSwitcherManager>
        </MockedAuthManager>
    );
};

const meta = {
    title: "Screens/ID Verification Retry",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
